import script from "./SpvModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SpvModal.vue?vue&type=script&setup=true&lang=js"

import "./SpvModal.vue?vue&type=style&index=0&id=71cc0ad4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71cc0ad4"]])

export default __exports__